import { Schema as ProductsSchema } from "@comparaonline/products-schema";
import { Schema as QuoterSchema } from "@comparaonline/quoter-schema";
import { getAttributes } from "../../../../../../models/product/getAttributes";

import { IAttributesProps } from "../../Attributes";

export const getAttributesProps = (
  product: ProductsSchema.ProductListProduct | QuoterSchema.Product
): IAttributesProps => {
  const attributes = getAttributes(product);
  return {
    attributes: product.mainAttribute ? attributes : attributes.slice(1)
  };
};
